import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CHECKOUT_URL, BUY_ANCHOR } from '../utils/constants';
import { CtaButton } from './CtaButton';
const INCLUDED = ['Complete Professional 6-Module System', '5 Strategic Bonuses', 'Complete Lesson Planning System', 'Grammar & Language Teaching Resources', 'Real-Life Vocabulary Resources', 'Speaking & Conversation Library', 'Ready-to-Use Spanish Activities', 'Progression & Assessment Tools', 'Lifetime Access', 'Instant Digital Delivery'];
export function Pricing() {
  return <section id={BUY_ANCHOR} aria-labelledby="pricing-title" className="w-full scroll-mt-10 bg-cream px-4 py-8" data-id="element-153" data-mp="1ruj7hr9br8rn">
      <div className="mx-auto max-w-xl text-center" data-id="element-154" data-mp="20t4qfnipkpsy">
        <h2 id="pricing-title" className="font-head text-2xl font-bold uppercase leading-[0.98] text-night sm:text-4xl" data-id="element-155" data-mp="20sd12ufpfob4">
          Everything is included. One price.
        </h2>
        <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-wide text-night/55" data-id="element-156" data-mp="3c936ibcb0c3o">
          No subscription. No hidden fees.
        </p>

        <div className="mt-3 overflow-hidden rounded-2xl border-2 border-brand bg-white text-left" data-id="element-157" data-mp="3w1t7vvjtp176">
          <div className="bg-brand px-4 py-2.5 text-center text-white" data-id="element-158" data-mp="4uyucy7xm497">
            <h3 className="font-head text-sm font-bold uppercase leading-tight sm:text-lg" data-id="element-159" data-mp="9sryzmtl6q7d">
              Spanish Teacher Pro™ — Complete System
            </h3>
            <p className="text-[10px] text-white/80 sm:text-xs" data-id="element-160" data-mp="3d9qnc94290rn">
              1 Complete System With 6 Modules + 5 Strategic Bonuses
            </p>
          </div>

          <div className="p-4" data-id="element-161" data-mp="3i5pg08wf94xv">
            <p className="font-head text-[10px] font-semibold uppercase tracking-widest text-night/55" data-id="element-162" data-mp="3n6vbufldp8bm">
              What’s included
            </p>
            <ul className="mt-1 grid gap-0.5 sm:grid-cols-2" data-id="element-163" data-mp="3rzy7qudmotuz">
              {INCLUDED.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] leading-snug text-night/80" data-id="element-164" data-mp="2uhy3b46yypw2">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-cta-dark" aria-hidden="true" data-id="element-165" data-mp="2zfpu1uvvo5yo" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-3 rounded-xl bg-cream p-3 text-center" data-id="element-166" data-mp="2mgqkjrcin7p3">
              <p className="text-[12px] text-night/60" data-id="element-167" data-mp="316ehkgdnzk70">
                Regular Price: <span className="line-through" data-id="element-168" data-mp="318imn1naup8v">$97</span>
              </p>
              <p className="font-head text-4xl font-bold leading-none text-brand sm:text-5xl" data-id="element-169" data-mp="2w83a2caudlry">$27</p>
              <span className="mt-1 inline-block rounded-full bg-coral px-2.5 py-0.5 font-head text-[10px] font-bold uppercase tracking-wide text-white" data-id="element-170" data-mp="28iinljfhc6dx">
                Save $70
              </span>
              <p className="mt-1 text-[10px] font-semibold uppercase tracking-widest text-night" data-id="element-171" data-mp="2ihrdo17850v0">
                One-Time Payment · Lifetime Access
              </p>
            </div>

            <div className="mt-3 flex flex-col items-center" data-id="element-172" data-mp="3tu0lxqupusux">
              <CtaButton href={CHECKOUT_URL} data-id="element-173" data-mp="3owikelj13fwy" />
              <p className="mt-1 text-[10px] text-night/55" data-id="element-174" data-mp="3ovqp7btcfk77">
                Protected by our 7-day money-back guarantee.
              </p>
              <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-0.5 text-[9px] font-semibold uppercase tracking-wide text-night/55" data-id="element-175" data-mp="59gno47o3nnt">
                <li className="flex items-center gap-1" data-id="element-176" data-mp="3ngwfsgi91085">
                  <LockIcon className="h-3 w-3 text-brand" aria-hidden="true" data-id="element-177" data-mp="3rfwupnxlvipv" />
                  Secure Payment
                </li>
                <li className="flex items-center gap-1" data-id="element-178" data-mp="j1es41qfovdn">
                  <ZapIcon className="h-3 w-3 text-brand" aria-hidden="true" data-id="element-179" data-mp="o0hluq0yrf6b" />
                  Instant Access
                </li>
                <li className="flex items-center gap-1" data-id="element-180" data-mp="a7s10ox68gas">
                  <CreditCardIcon className="h-3 w-3 text-brand" aria-hidden="true" data-id="element-181" data-mp="e9wspi4272us" />
                  Card · Google Pay · Apple Pay
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}